<div class="sm-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="sm-modal" (click)="$event.stopPropagation()">

    <!-- ── Header ─────────────────────────────────────────────────── -->
    <div class="sm-header">
      <div class="sm-header__left">
        <div class="sm-header__icon-wrap">
          <img [src]="headerIconSrc" alt="Summary" class="sm-header__icon" />
        </div>
        <h2 class="sm-header__title">{{ headerTitle }}</h2>
      </div>
      <div class="sm-header__actions">
        <button class="sm-header__btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </button>
        <button class="sm-header__btn sm-header__btn--close" (click)="close()">✕</button>
      </div>
    </div>

    <!-- ── Body ───────────────────────────────────────────────────── -->
    <div class="sm-body">

      <!-- Left Column -->
      <div class="sm-col sm-col--left">

        <!-- AI Text Box -->
        <div class="sm-ai-box">
          <p class="sm-ai-box__text">{{ aiText }}</p>
        </div>

        <!-- Mini Summary Table -->
        <div class="sm-table-wrap">
          <table class="sm-table">
            <thead>
              <tr>
                <th *ngFor="let col of tableColumns" [class.sm-table__th--cis]="col === 'CIS'">{{ col }}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="sm-table__region">{{ summaryRow.region }}</td>
                <td class="sm-table__score">{{ summaryRow.hseIp }}</td>
                <td class="sm-table__score">{{ summaryRow.lti }}</td>
                <td class="sm-table__score">{{ summaryRow.cre }}</td>
                <td class="sm-table__cis">
                  <div class="sm-table__cis-cell">
                    <span class="sm-table__cis-val">{{ summaryRow.cis }}</span>
                    <ng-container [ngSwitch]="summaryRow.cisTrend">
                      <svg *ngSwitchCase="'up'" width="7" height="10" viewBox="0 0 7 10" fill="none">
                        <path d="M3.50391 9.5V0.5" stroke="#009146" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.50756 2L3.50378 0.5L0.5 2" stroke="#009146" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <svg *ngSwitchCase="'down'" width="7" height="10" viewBox="0 0 7 10" fill="none">
                        <path d="M3.50391 0.5V9.5" stroke="#F00014" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M6.50756 8L3.50378 9.5L0.5 8" stroke="#F00014" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span *ngSwitchDefault>-</span>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- HSE Improvement Plan Card -->
        <div class="sm-mini-card">
          <div class="sm-mini-card__header">
            <img [src]="hseCard.iconSrc" [alt]="hseCard.iconAlt" class="sm-mini-card__icon" />
            <div>
              <p class="sm-mini-card__title">{{ hseCard.title }}</p>
              <p class="sm-mini-card__sub">{{ hseCard.subtitle }}</p>
            </div>
          </div>
          <div class="sm-mini-card__chart" [style.background]="chartBg(hseScore)">
            <span class="sm-mini-card__score">{{ hseScore }}%</span>
            <div #hseChartEl class="sm-apex-sparkline"></div>
          </div>
        </div>

        <!-- LTI Card -->
        <div class="sm-mini-card">
          <div class="sm-mini-card__header">
            <img [src]="ltiCard.iconSrc" [alt]="ltiCard.iconAlt" class="sm-mini-card__icon" />
            <div>
              <p class="sm-mini-card__title">{{ ltiCard.title }}</p>
              <p class="sm-mini-card__sub">{{ ltiCard.subtitle }}</p>
            </div>
          </div>
          <div class="sm-mini-card__chart" [style.background]="chartBg(ltiScore ?? 0)">
            <span class="sm-mini-card__score">{{ ltiScore !== null ? ltiScore + '%' : '—' }}</span>
            <div #ltiChartEl class="sm-apex-sparkline"></div>
          </div>
          <div class="sm-lti-list">
            <p class="sm-lti-list__label">{{ "MOST_RECENT_LTIS" | translate }}</p>
            <ul>
              <li *ngFor="let lti of recentLtis">{{ lti }}</li>
            </ul>
          </div>
        </div>

      </div>

      <!-- Right Column -->
      <div class="sm-col sm-col--right">

        <!-- CRE Card -->
        <div class="sm-mini-card">
          <div class="sm-mini-card__header">
            <img [src]="creCard.iconSrc" [alt]="creCard.iconAlt" class="sm-mini-card__icon" />
            <div>
              <p class="sm-mini-card__title">{{ creCard.title }}</p>
              <p class="sm-mini-card__sub">{{ creCard.subtitle }}</p>
            </div>
          </div>
          <div class="sm-mini-card__chart" [style.background]="chartBg(creScore)">
            <span class="sm-mini-card__score">{{ creScore }}%</span>
            <div #creChartEl class="sm-apex-sparkline"></div>
          </div>
          <div class="sm-overdue">
            <p class="sm-overdue__title">{{ overdueTitle }}<br/><span>{{ overdueSubtitle }}</span></p>
            <div class="sm-overdue__scroll">
              <table class="sm-overdue__table">
                <colgroup>
                  <col class="col-date" />
                  <col class="col-location" />
                  <col class="col-level" />
                </colgroup>
                <thead>
                  <tr>
                    <th *ngFor="let col of overdueColumns">
                      {{ col }} <span class="sm-overdue__search"><img [src]="searchIconSrc" alt="search" /></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of overdueFindings">
                    <td [style.color]="row.dateColor" class="sm-overdue__date">{{ row.date }}</td>
                    <td>{{ row.location }}</td>
                    <td class="sm-overdue__level">
                      {{ row.level }}
                      <button class="sm-overdue__view-btn" (click)="openFindingDetails(row); $event.stopPropagation()">{{ "VIEW" | translate }}</button>
                    </td>
                  </tr>
                  <tr *ngIf="overdueFindings.length === 0">
                    <td colspan="3" class="sm-overdue__empty">No overdue CRE findings</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

      </div>
    </div>

  </div>
</div>
